import script from "./HomeCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&setup=true&lang=js"

import "./HomeCarousel.vue?vue&type=style&index=0&id=20880fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20880fca"]])

export default __exports__